export default async function init() {
  const elements = document.querySelectorAll('.teaser-row[data-filter]');

  if (elements.length) {
    const { default: TeaserRow } = await import(/* webpackChunkName: "teaser-row" */ './teaser-row');

    elements.forEach((element) => new TeaserRow(element));
  }
}
